<template>
  <div style="background-color: #f2f2f2;height: 100%;">
    <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
      人员分类统计
    </div>
    <div style="padding: 20px;" class="summary100">
      <div v-if="showModal" class="mask">
        <div class="lodingsIcon">
          <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
        </div>
      </div>
      <div>
        <el-row>
          <el-button type="success" style="margin-right:10px" @click="statistic">月度统计</el-button>
          <div style="float:right">
            <span class="demonstration">补助类型：</span>
            <el-select v-model="elderlyClass" placeholder="请选择补助类型" clearable  style="width:250px;margin-right:20px">
              <el-option
                  v-for="item in elderlyClassList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
              </el-option>
            </el-select>
            <span class="demonstration">所属区域：</span>
            <elSelectTree :options='zoneValue' accordion :props="zoneProps" placeholder="请选择所属区域"
                          v-on:getZoneValue="getZoneValue" style="width:250px;margin-right:20px"></elSelectTree>
            <span class="demonstration">起止时间：</span>
            <el-date-picker
                ref="picker"
                v-model="datetimerangeValue"
                :unlink-panels='true'
                type="daterange"
                :clearable='false'
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:250px;margin-right:20px">
            </el-date-picker>
            <el-button type="success" icon="el-icon-download" style="margin-right:10px" @click="download">导出</el-button>
            <el-button type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
          </div>
        </el-row>
        <div style="clear: both;"></div>
      </div>
      <div style="height: 10px;"></div>
      <div>
        <template>
          <el-table :data="tableData" :height="th" border style="width: 100%;">
            <el-table-column label="编号" type="index" :formatter="getId" width="85"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="age" :formatter="getAge" label="年龄"></el-table-column>
            <el-table-column prop="idCard" label="身份证号码"></el-table-column>
            <el-table-column prop="userPhone" label="手机号"></el-table-column>
            <el-table-column prop="zoneName" label="所属区域"></el-table-column>
            <el-table-column prop="elderlyClass" :formatter="getElderlyClass" label="补助类型"></el-table-column>
          </el-table>

          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div style="float: left;padding: 5px;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
            <div style="float: left;">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>


        </template>
      </div>

    </div>

    <StatisticsForMonth ref="myStatisticsForMonth" v-show="showStatisticsForMonth"
                        v-on:closeStatisticsForMonth="closeStatisticsForMonth"></StatisticsForMonth>


  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import StatisticsForMonth from "@/views/ElderlyReport/StatisticsForMonth";
import elSelectTree from "../../components/ElSelectTree"
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Role",
  data() {
    return {
      showStatisticsForMonth: false,
      loading: false,
      tableData: null,
      datetimerangeValue: '',
      totalItems: 0,
      elderlyClass: '',
      showModal: false,
      pageSize: 20,
      imgUrl: this.$imgUrl,
      currentPage: 1,
      zoneValue: [],
      zoneCode: '00000000-0000-0000-0000-000000000000',
      th: 0,
      name: '',
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },
      elderlyClassList: ''
    }
  },
  components: {
    elSelectTree, StatisticsForMonth
  },
  created() {
    this.init();
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      console.log(val);
      this.th = val;
    },
  },
  methods: {

    init() {
      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 365);
      this.datetimerangeValue = [start, end];
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              var data = JSON.stringify(response.data.data);
              data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
              this.zoneValue = data;
            } else if (response.data.error == 1) {
              this.$message.error(response.data.message)
            }
          }
      )
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ElderlyClass/List",
        data: {
          timeStr: timeStr,
          staffCode: getStaffCode(),
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey)
        }
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.elderlyClassList = response.data.data;
            } else if (response.data.error == 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    closeStatisticsForMonth() {
      this.showStatisticsForMonth = !this.showStatisticsForMonth;
    },

    getElderlyClass(row) {
      for (var i=0;i<this.elderlyClassList.length;i++){
        if(row.elderlyClass===this.elderlyClassList[i].value){
          return this.elderlyClassList[i].name;
        }
      }
    },
    allStatus(row, status) {
      for (var i in status) {
        if (status[i].value == row) {
          return status[i].label
        }
      }
      return "其它";
    },
    statistic() {
      this.$refs.myStatisticsForMonth.init();
      this.showStatisticsForMonth = !this.showStatisticsForMonth;
    },
    getAge(row) {
      var identityCard = row.idCard;

      var len = (identityCard + "").length;
      if (len == 0) {
        return 0;
      } else {
        if ((len != 15) && (len != 18))//身份证号码只能为15位或18位其它不合法
        {
          return 0;
        }
      }
      var strBirthday = "";
      if (len == 18)//处理18位的身份证号码从号码中得到生日和性别代码
      {
        strBirthday = identityCard.substr(6, 4) + "/" + identityCard.substr(10, 2) + "/" + identityCard.substr(12, 2);
      }
      if (len == 15) {
        strBirthday = "19" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
      }
      //时间字符串里，必须是“/”
      var birthDate = new Date(strBirthday);
      var nowDateTime = new Date();
      var age = nowDateTime.getFullYear() - birthDate.getFullYear();
      //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
      if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;

    },
    download() {
      this.$confirm('是否导出当前列表?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.showModal = true
        var that = this
        var zoneCode = '00000000-0000-0000-0000-000000000000'
        if (this.zoneCode) {
          zoneCode = this.zoneCode
        }
        this.$axios.get(this.$shopUrl + 'ExportElderly/getElderlyClassifyToGovernment', {
          responseType: 'blob',
          params: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            startTime: timefilters(this.datetimerangeValue[0]),
            endTime: timefilters(this.datetimerangeValue[1]),
            zoneCode: zoneCode,
            elderlyClass: this.elderlyClass
          }
        }).then(
            (response) => {
              if (response.data.type == 'application/json') {
                this.$message({type: 'info', message: '暂无数据'});
                that.showModal = false;
              } else {
                let fileName = '人员分类统计.xlsx';
                that.file(response, fileName);
                that.showModal = false;
              }

            }
        )
        this.dialogFormVisible = false
      }).catch(e => e)
    },
    file(response, fileName) {
      let blob = new Blob([response.data]);
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        let elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      }
    },
    getId(index) {
      return index
    },
    getZoneValue(val) {
      this.zoneCode = val
    },
    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    timefilter(row, column, cellValue) {
      return timefilters(cellValue)
    },
    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },
    toggleModalEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getList() {
      var zoneCode = '00000000-0000-0000-0000-000000000000'
      if (this.zoneCode) {
        zoneCode = this.zoneCode
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Elderly/GetElderlyClassPage",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          startTime: timefilters(this.datetimerangeValue[0]),
          endTime: timefilters(this.datetimerangeValue[1]),
          zoneCode: zoneCode,
          elderlyClass: this.elderlyClass
        }
      }).then((response) => {
        console.log(response);
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    statusTitle(row) {
      if (row.status == 0) {
        return "正常";
      }
      if (row.status == 1) {
        return "禁用";
      }
      return "其它";
    },


  }
}
</script>

<style lang="scss" scoped>
.summary100 {
  .mask {
    background-color: rgb(0, 0, 0);
    opacity: 0.3;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 199
  }

  .mask .lodingsIcon {
    /* margin-top: 47vh; */
    margin: 47vh auto;
    height: 6vh;
    width: 300px;
    font-size: 18px;
    color: white;
  }

  .lodingsIcon i {
    z-index: 200;
    font-size: 25px;
    margin-right: 10px;
  }
}
</style>
